export default __webpack_public_path__ + "static/media/LSTM-2CNN.de0202b9.png";